const en = {
  maintenance: {
    underMaintenance: "Nights is under maintenance",
    backSoon:
      "Nightz is under maintenance to bring improvements and provide you with the best experience. Sorry for the inconvenience, we will be back online soon!",
  },
  confirmation: {
    close: "Close",
    delete: "Delete",
    accept: "Accept",
    cancel: "Cancel",
    save: "Save",
    edit: "Edit",
    confirmDeleteDialogStandardTitle: "Delete",
    confirmDeleteDialogStandardDescription: "Are you sure want to delete?",
  },

  daysOfTheWeek: {
    monday: "monday",
    tuesday: "tuesday",
    wednesday: "wednesday",
    thursday: "thursday",
    friday: "friday",
    saturday: "saturday",
    sunday: "sunday",
  },
  daysOfTheWeekShort: {
    monday: "Mon",
    tuesday: "Tue",
    wednesday: "Wed",
    thursday: "Thu",
    friday: "Fri",
    saturday: "Sat",
    sunday: "Sun",
  },
  guards: {
    permissionDenied: {
      title: "Permission denied",
      body: "You do not have permission to access this page.",
    },
  },

  login: {
    title: "Hi, Welcome back",
    header: "Sign in to Nightz",
    no_account: "New user?",
    start_now: "Create an account",
    submit: "Login",
    forgot_password: "Forgot password?",
    continueWithEmail: "Continue with email",
    fields: {
      emailOrPhone: "Email or phone",
      password: "Password",
    },
    validation: {
      emailOrPhone_required: "Email or phone is required",
      password_required: "Password is required",
    },
    errors: {
      Incorrectemailorphoneorpassword: "Incorrect credentials",
      Toomanyfailedattemptsofloginpleaseresetyourpassword:
        "Too many failed login attempts. Please reset your password!",
      Incorrectinfo: "Incorrect credentials"
    },
    withSocials: {
      or: "OR",
    },
  },

  accountMenu: {
    message: "Hello! To continue, please log in or create a new account",
    login: "Login",
    register: "Register",
    logout: "Logout",
    home: "Home",
    tickets: "Tickets and Reservations",
    myCart: "My Cart",
    profile: "My Account",
    myDashboard: "My Dashboard",
    invoices: "Invoices",
    invoicesDrafts: "Invoices Drafts",
    invoicesDraft: "Invoice Draft",
  },

  registerPage: {
    pageTitle: "Register",
    pageMessage: "Register to Nightz",
    title: "Get started absolutely free.",
    subTitle: "Find parties everywhere.",
    accountType: "Account Type",
    userType: "User",
    companyType: "Company",
    firstName: "First Name",
    lastName: "Last Name",
    emailAddress: "Email Address",
    password: "Password",
    register: "Register",
    message1: "By registering, I agree to Nightz",
    message2: "and",
    termsAndConditionsTitle: "Terms and Conditions",
    termsAndConditions: "Terms and Conditions",
    privacyPolicy: "Privacy Policy",
    alreadyAccount: "Already have an account?",
    login: "Login",
    firstNameRequired: "First name is required",
    lastNameRequired: "Last name is required",
    emailAddressRequired: "Email address is required",
    passwordRequired: "Password is required",
    invalidEmail: "Email must be a valid email address",
    genericError: "A problem occurred! Please try again later.",
  },

  search: {
    notFound: "Not found",
    noResult: "No results found for",
    tryTypos: "Try checking for typos or using complete words.",
    enterKeywords: "Please enter keywords",
    searchBar: "Search",
  },

  userProfile: {
    title: "Account",
    general: "General",
    notifications: "Notifications",
    socialLinks: "Social Links",
    changePassword: "Change Password",
  },

  userTicketsPage: {
    title: "My Activities",
    myAccount: "My Account",
    tickets: "Tickets and Reservations",
    upcomingEvents: "Upcoming Activities",
    upcomingBookings: "Upcoming Reservations",
    pastEvents: "Past Activities",
    pastBookings: "Past Reservations",
    noPastEventsTickets: "You have no reservations for past events",
    noUpcomingEventsTickets: "You have no reservations for upcoming events",
  },

  checkoutPage: {
    cartMaxQuantity1: "You cannot add more than",
    cartMaxQuantity2: "tickets in cart.",
  },

  accountGeneral: {
    firstName: "First Name",
    lastName: "Last Name",
    username: "User Name",
    phoneNumber: "Phone Number",
    country: "Country",
    city: "City",
    about: "About",
    saveChanges: "Save Changes",
    formatAllowed: "Allowed *.jpeg, *.jpg, *.png",
    maxSize: "Max size {{size}}",
    dashboard: "Dashboard",
    user: "User",
    accountSettings: "Account Settings",
    updateSuccess: "Update success!",
  },

  imageCropper: {
    save: "Save",
    remove: "Remove",
    cancel: "Cancel",
    editImage: "Edit Image",
  },

  listingList: {
    title: "Listings",
    subtitleNightz: "Entertainment, dining & relaxing",
    subtitleDayz: "Business, networking & learning",
    freeEntry: "Free Entry",
    allCountry: "All Country",
    startingFrom: "Starting from",
    seeMore: "See more",
    seeLess: "See less",
  },

  listingOpenApp: {
    title: "Cheaper tickets in the mobile app",
    description: "Download the Nightz app and receive exclusive offers for events and restaurants in your city!",
    continueInApp: "Continue with discount in app",
    continueInWeb: "Buy with full price in website",
  },

  tickets: {
    other: "Other",
    dates: "Dates",
    configuration: "Configuration",
    spotsLeft: "spots left",
    left: "LEFT",
    loadingDates: "Loading dates...",
    noTickets: "There are no tickets left",
    seeMoreDates: "See more dates"
  },

  bookings: {
    tablesUpper: "Tables",
    areasUpper: "Areas",
    optionsUpper: "Options",
    plusOneDay: " (+ 1 day)",
    eventCreatedSuccessfully: "Event created successfully!",
    publish: "Go publish it now",
    goToEvent: "Go to event",
    ongoingEvent: "Ongoing Event",
    addEvent: "Add Event",
    addNewEvent: "Add New Event",
    createEvent: "Create Event",
    comments: "Comments",
    holdingFeeFor: "Holding fee for",
    items: "Items",
    orderDetails: "Order Details",
    error: "An error occurred, please try again",
    errorNoPermissionCompany: "A company is not allowed to make a reservation",
    successReservationMade:
      "A reservation request has been successfully made. Check your email or phone for more info!",
    errorNotEnoughPlaces:
      "A reservation can't be made because there are not enough places. " +
      "Please try and contact the organizer for further info",
    contactDetails: "Contact details",
    back: "Back",
    continue: "Continue",
    successCancel: "Booking cancel successfully!",
    cancelError: "There was an error, please try again. cancel",
    noAvailibityError: "There are no more options available. Please try a different combination.",
    numberOfGuest: "guest",
    numberOfGuests: "guests",
    yes: "Yes",
    no: "No",
    busy: "Busy",
    alertTitle: "Are you sure?",
    alertText: "Are you sure you want to cancel this reservation?",
    addTable: "Add table",
    addOption: "Add option",
    title: "Reservations",
    on: "Bookings on",
    approve: "Approve",
    remove: "Remove",
    modify: "Modify",
    confirmed: "Confirmed",
    waiting_for_payment: "Waiting for payment",
    pending: "Pending",
    canceled: "Cancelled",
    blocked: "Blocked",
    blockedInterval: "Blocked Interval",
    deleted_by_venue: "Deleted by venue",
    cancel_by_user: "Cancelled by user",
    cancel_by_venue: "Cancelled by venue",
    denied: "Denied",
    enabled: "Enabled",
    disabled: "Disabled",
    deleteError: "There was an error, please try again.",
    createError: "There was an error, please try again.",
    rescheduleError: "There was an error, please try again.",
    blockError: "There was an error, please try again.",
    noStatus: "No status",
    newReservation: "Reserve",
    blockInterval: "Block",
    tables: "tables",
    options: "options",
    option: "option",
    table: "table",
    allTablesAdded: "All tables added",
    oneButtonLeft: "1 button left",
    allButtonsAdded: "All buttons added",
    left: "left",
    category: "Category",
    area: "Area",
    person: "person",
    persons: "persons",
    guests: "Guests",
    time: "Time",
    date: "Date",
    today: "Today",
    tomorrow: "Tomorrow",
    save: "Save",
    delete: "Delete",
    deny: "Deny",
    cancel: "Cancel",
    fullName: "Full name",
    name: "Name",
    phoneNumber: "Phone number",
    email: "Email",
    contact: "Contact Details",
    length: "Length",
    cancelReservation: "Cancel Reservation",
    type: "Type...",
    tooManyGuests:
      "Warning! The capacity of the selected tables is not enough for the selected guests. The booking can still be saved",
    outsideBusinessHours: "The selected time is outside the business hours",
    startTimeIsInvalid: "The selected start time is invalid",
    endTimeIsInvalid: "The selected end time is invalid",
    closedDay: "The selected day is closed",
    approveReservation: "Approve Reservation?",
    deleteReservation: "Remove Reservation?",
    giveUp: "Close",
    reservationApproved: "Reservation approved successfully!",
    reservationDeleted: "Reservation deleted successfully!",
    noAvailableBookingCardOptions:
      "No options available. Please try a different combination.",
    allTablesSoldOut:
      "All tables have been booked!",
    allOptionsSoldOut:
      "All options have been booked!",
    loadingBookingCardOptions: "Please wait.",
    visit: "visit",
    visits: "visits",
    visitsUppercase: "Visits",
    lastVisit: "Last visit",
    dragToMove: "Drag to move around",
    bookTableYouWant1: "See the venue and book",
    bookTableYouWant2: "the exact table you want",
    exploreTheVenue: "Explore the venue in 3D and choose the best table, just like a VIP. This exclusive feature is available only in our mobile app.",
    chooseYourTable: "Choose your table in the app",
    randomAllocation: "Continue with random allocation",
    specialRequirements: "Tell us more about your preferences so we can provide the best experience.",
    specialOccasions: "Special Occasion",
    dietaryRestrictions: "Dietary Restrictions",
    tableRequirements: "Table Requirements",
    clientTags: "Client tags",
    specialOccasionsTitle: "Is this a special occasion?",
    userDietaryRestrictionsTitle: "Do you have any dietary restrictions?",
    partyDietaryRestrictionsTitle: "Does your party have any dietary restrictions?",
    anythingElseTitle: "Anything else to make your visit better?",
    characters: "characters",
    reservationTags: "Reservation Tags",
    add: "Add",
    selectTable: "Select at least one table",
    showMore: "Show more",
    showLess: "Show less",
    formValidation: {
      statusRequired: "Status is required.",
      guestsRequired: "Number of guests is required.",
      guestsMin: "Required",
      dateRequired: "Date is required.",
      startTimeRequired: "Start time is required.",
      endTimeRequired: "End time is required.",
      areaRequired: "Area is required.",
      categoryRequired: "Category is required.",
      tablesRequired: "At least one table is required.",
      optionsRequired: "At least one option is required.",
      fullNameRequired: "Full name is required.",
      phoneNumber: "Phone number is required.",
      phoneNumberLength: "Please provide a correct phone number",
      emailRequired: "Email is required.",
      emailValid: "Please enter a valid email address.",
    },
    clientBookingValidation: {
      guestsRequired: "Number of guests is required.",
      dateRequired: "Date is required.",
      timeRequired: "Time is required.",
      areaRequired: "Area is required.",
      lengthRequired: "Length is required.",
    },
    bookingDetails: {
      title: "Reservation Details",
    },
    table: {
      name: "Name",
      status: "Status",
      guests: "Guests",
      searchByIdNamePhoneEmail: "Search by Name, Email, Phone or ID",
      area: "Area",
      category: "Category",
      tables: "Tables",
      options: "Options",
      time: "Booking date and time",
      phone: "Phone",
      email: "Email",
      id: "Reservation ID",
      reset: "Reset",
      reservationsTitle: "Reservations",
    },
    howItWorks: "How it works",
    holdingFee: "Holding Fee",
    holdingFeeDisclaimerShort: "This venue uses a holding fee to confirm reservations and avoid no-shows.",
    holdingFeeDisclaimer:
      "This venue uses a holding fee to confirm reservations and avoid no-shows. This amount is going to be discounted from your bill.",
    overMaxBookingGuests1: "For more than",
    overMaxBookingGuests2: "persons, please call the venue to book. Phone number:",
    underMinBookingGuests1: "For less than",
    underMinBookingGuests2: "persons, you don't need to make a reservation at this venue."
  },
  bookingTags: {
    Anniversary: "Anniversary",
    Bachelor: "Bachelor",
    Bachelorette: "Bachelorette",
    Birthday: "Birthday",
    BridalShower: "Bridal Shower",
    BusinessMeeting: "Business Meeting",
    Engagement: "Engagement",
    Graduation: "Graduation",
    Honeymoon: "Honeymoon",
    AlcoholFree: "Alcohol-Free",
    Allium: "Allium",
    Celery: "Celery",
    Crustacean: "Crustacean",
    DairyFree: "Dairy-Free",
    Diabetic: "Diabetic",
    Eggs: "Eggs",
    Fish: "Fish",
    GlutenFree: "Gluten-Free",
    Halal: "Halal",
    Kosher: "Kosher",
    LactoseIntolerant: "Lactose Intolerant",
    Lupin: "Lupin",
    MilkDairy: "Milk/Dairy",
    Mollusc: "Mollusc",
    Mustard: "Mustard",
    Nightshade: "Nightshade",
    Paleo: "Paleo",
    Peanuts: "Peanuts",
    Pescatarian: "Pescatarian",
    Pork: "Pork",
    Poultry: "Poultry",
    Pregnant: "Pregnant",
    RedMeat: "Red Meat",
    Salt: "Salt",
    Seafood: "Seafood",
    Sesame: "Sesame",
    Shellfish: "Shellfish",
    Soy: "Soy",
    Sulfites: "Sulfites",
    TreeNuts: "Tree Nuts",
    Vegan: "Vegan",
    Vegetarian: "Vegetarian",
    Wheat: "Wheat",
    FirstVisit: "First Visit",
    FoodCritic: "Food Critic",
    FrequentCancellations: "Frequent Cancellations",
    FrequentNoShow: "Frequent No-Show",
    HighSpender: "High Spender",
    Media: "Media",
    Regular: "Regular",
    StaffAcquaintance: "Staff Acquaintance",
    VIP: "VIP",
    AccessibleEntrance: "Accessible Entrance",
    BabySeat: "Baby Seat",
    BarSeat: "Bar Seat",
    Booth: "Booth",
    ExtendedStay: "Extended Stay",
    GuideDog: "Guide Dog",
    HighTable: "High Table",
    Indoor: "Indoor",
    NonSmoking: "Non-Smoking",
    Outdoor: "Outdoor",
    Patio: "Patio",
    PrivateDining: "Private Dining",
    QuietArea: "Quiet Area",
    Smoking: "Smoking",
    Terrace: "Terrace",
    WheelchairAccessible: "Wheelchair Accessible",
    WindowSeat: "Window Seat",
  },
  bookingWizard: {
    title: "Choose your preference",
    tickets: "Tickets",
    booking: "Table",
    options: "Options",
    bookingMenu: "Menu",
    seatsTitle: "Choose your seats",
  },

  checkout: {
    cart: {
      cart: "Cart",
      clearCart: "Clear Cart",
      clearCartSubtitle: "Are you sure you want to remove all items from your cart?",
      ticketsMaxQuantity: "You cannot add more tickets!",
      increase: "Quantity increased",
      decrease: "Quantity decreased",
      itemDelete: "Item deleted successfully!",
      itemDeleteError: "Item delete failed!",
      itemUpdateError: "Item update failed!",
    },
    congrats: {
      "ticket": "Congratulations! You have bought your tickets!",
      "table": "Congratulations! Your reservation is confirmed!",
      "tablePending": "Congratulations! Your reservation is pending!",
      "order": "Congratulations! Your order is completed!",
      "ticketAction": "See tickets",
      "tableAction": "See reservation",
      "orderAction": "See details",
      "callToAction": "Awesome, thanks!"
    },
    invoiceDetails: "Invoice Details",
    personalDetails: "Personal Details",
    title: "Checkout",
    item: "item",
    items: "items",
    emptyCartTitle: "Cart is empty",
    emptyCartDescription: "Looks like you have no items in your shopping cart.",
    continueShopping: "Continue shopping",
    orderSummary: "Order summary",
    checkout: "Checkout",
    cartMaxQuantity: "You cannot add more than 50 items in cart!",
    acceptTermsAndConditions: "Please accept terms and conditions",
    subtotal: "Subtotal",
    discount: "Discount",
    processingFee: "Processing fee",
    paymentMethodFee: "Payment method fee",
    vatIncluded: "VAT included if applicable.",
    discountCode: "Discount/Gift code",
    applyDiscount: "Apply",
    promoCodeApplied: "Discount/Gift code applied successfully.",
    product: "Product",
    products: "Products",
    seat: "Seats",
    selection: "Selection",
    price: "Price",
    quantity: "Quantity",
    totalPrice: "Total price",
    ticketType: "Ticket type",
    ticketTypeName: " Ticket Name",
    available: "Available",
    changeQty: "Modify",
    iReadAndAgree: "I read and I agree with the",
    agreeToCampaign: "I agree to receive information about future events.",
    personalInvoice: "Personal invoice",
    businessInvoice: "Business invoice",
    sameAsPersonal: "Invoice details same as personal details",
    billing: {
      addressTitle: "Billing address",
      title: "Please complete the following form with your data",
      validation: {
        firstName: "First name is required",
        lastName: "Last name is required",
        postCode: "Postal code is required",
        digits: "Postal code must contain only digits",
        phoneDigits: "Phone number must contain only digits",
        phoneMax: "Phone number must be a maximum of 15 digits",
        phoneMin: "Phone number must be a minimum of 7 digits",
        phone: "Phone number is required",
        email: "Email address is required",
        emailFormat: "Invalid email address",
        emailsMatching: "Emails must match",
        address: "Address is required",
        city: "City is required",
        state: "County is required",
      },
      firstName: "First name",
      lastName: "Last name",
      address: "Address",
      city: "Town / City",
      phone: "Phone number",
      email: "Email address",
      validateEmail: "Confirm email address",
      state: "County",
      country: "Country",
      postCode: "Postal code",
      back: "Back",
      continueToPayment: "Continue to payment",
    },
    completeOrder: "Complete order",
    edit: "Edit",
    emailDelivery: "Email delivery",
    deliveryOptions: "Delivery options",
    payment: {
      payment: "Delivery and Payment",
      options: "Payment options",
      title1: "Pay with a new card",
      title2: "Pay with an existing card",
      titlePlatform: "Use Google / Apple Pay",
      confirm: "Confirm Payment",
      description:
        "You will be redirected to Banca Transilvania website to safely complete your purchase.",
      cards: "Cards",
      expiration: "Expires in",
      newCard: "Add new card",
      deleteCard: "Delete selected card",
      loading: "Please don't close the window. Processing request.",
      cancel: "Cancel",
    },
    genericError: "A problem occurred! Please try again later.",
    ticketInviteError: "You cannot send ticket invites to a company email. Please try again.",
    notEnoughCapacityError: "Not enough spots left for this session. Please try again.",
    errors: {
      noPromoCodeError: "This discount/gift code is not available!",
      noOnlySpacesError: "Input cannot contain only space",
    },
    success: {
      title: "Thank you for your purchase!",
      order1: "Order",
      order2: "has been placed.",
      mail: "Soon, you will receive an email with your purchased tickets.",
      mail2: "Soon, you will receive an email with your order details.",
      download: "Alternatively, you can download them using the button below.",
      problems: "If you have any problems, do not hesitate to contact us.",
    },
    fail: {
      title: "OOPS!",
      message1: "It looks like there was an error placing your order.",
      message2: "Please try again later.",
      messageCode_104: "Restricted card (temporarily or permanently blocked)",
      messageCode_124:
        "Transaction cannot be authorised due to government, central bank or financial institution consent, laws or regulations",
      messageCode_320: "Inactive card. Please activate the card.",
      messageCode_801: "Issuer unavailable.",
      messageCode_803:
        "Card blocked. Contact issuing bank or retry transaction with another card.",
      messageCode_804:
        "Transaction not allowed. Please contact issuing bank or retry transaction with another card.",
      messageCode_805: "Transaction rejected.",
      messageCode_861: "Wrong card expiry date.",
      messageCode_871: "Wrong CVV.",
      messageCode_905: "Invalid card. It does not exist in the database.",
      messageCode_906: "Card expired.",
      messageCode_913:
        "Invalid transaction. Contact issuing bank or retry transaction with another card.",
      messageCode_914: "Invalid account. Please contact issuing bank.",
      messageCode_915: "Insufficient funds.",
      messageCode_917: "Transaction limit exceeded.",
      messageCode_952: "Suspected fraud.",
      messageCode_998:
        "Installment transactions are not allowed with this card. Please use a credit card issued by Banca Transilvania.",
      messageCode_341016:
        "3DS2 authentication is declined by Authentication Response (ARes) – issuer",
      messageCode_341017:
        "3DS2 authentication status in ARes is unknown - issuer",
      messageCode_341018: "3DS2 CReq cancelled - client",
      messageCode_341019: "3DS2 CReq failed - client/issuer",
      messageCode_341020: "3DS2 unknown status in RReq - issuer",
    },
    paymentProcessorMaintenance:
      "Payment processor is under maintenance, please try again later!",
  },
  eventTicketsTable: {
    status: {
      ISSUED: "ISSUED",
      SCANNED: "SCANNED",
      REFUNDED: "REFUNDED",
      CREATED: "CREATED"
    },
    kind: {
      PRINTED: "PRINTED",
      REGULAR: "REGULAR",
      INVITE: "INVITE"
    },
    ticketKind: "Sale Type",
    ticketSeries: "Ticket Series",
    orderID: "Order ID",
    seatId: "Seat Number",
    buyerName: "Buyer Name",
    holderName: "Holder Name",
    ticketsType: "Ticket Type",
    ticketPrice: "Ticket Price",
    ticketStatus: "Ticket Status",
    phone: "Phone",
    email: "Email",
    itemId: "Order item ID",
    itemName: "Item Name",
    itemQuantity: "Quantity",
    itemUnitPrice: "Unit Price",
    title: "Order Items"
  },

  imageGallery: {
    title: "Drop or Select file",
    drop: "Drop files here or click ",
    browse: "browse",
    message: " thorough your machine.",
  },

  months: {
    january: "January",
    february: "February",
    march: "March",
    april: "April",
    may: "May",
    june: "June",
    july: "July",
    august: "August",
    september: "September",
    october: "October",
    november: "November",
    december: "December",
  },
  calendar: {
    month: 'Month',
    week: 'Week',
    day: 'Day'
  },


  passwordValidation: {
    uppercase: "At least one upper case letter",
    lowercase: "At least one lower case letter",
    number: "At least one digit",
    specialCharacter: "At least one symbol or special character",
    passwordLength: "At least 8 characters long",
  },

  changePassword: {
    oldPassword: "Old Password",
    newPassword: "New Password",
    confirmPassword: "Confirm New Password",
    oldPasswordRequired: "Old Password is required",
    newPasswordRequired: "New Password is required",
    newPasswordLength: "Password must be at least 6 characters",
    passwordMismatch: "Passwords must match",
    success: "Update success!",
    errors: {
      invalidoldpassword: "Old Password is wrong!",
    },
  },

  resetPassword: {
    passwordRecoveryPrompt: "Forgot your password?",
    passwordRecoveryInstructions:
      "Please enter the email address associated with your account and we will send you a code to reset your password.",
    resetPasswordInstructions1Email:
      "We've sent a 6-digit confirmation code to your email.",
    resetPasswordInstructions2Email:
      "Please enter the code in below box to verify your email.",
    resetPasswordInstructions1Phone:
      "We've sent a 6-digit confirmation code to your phone.",
    resetPasswordInstructions2Phone:
      "Please enter the code in below box to verify your phone number.",
    returnToSignIn: "Return to sign in",
    emailOrPhoneRequired: "Email is required",
    emailOrPhone: "Email",
    sendRequest: "Send Request",
    passwordCharLimit: "Password must be at least 6 characters",
    passwordRequired: "Password is required",
    confirmPassRequired: "Confirm password is required",
    passMismatch: "Passwords must match",
    password: "New Password",
    confirmPassword: "Confirm New Password",
    changePasswordSuccess: "Change password success!",
    updatePassword: "Update Password",
    requestSentSuccessfully: "Request sent successfully!",
    codeRequired: "Code is required",
    errors: {
      invalidcode: "The code is invalid!",
      usernotfound: "No user was found with that email address!",
    },
  },

  productPage: {
    upcomingEvents: "Upcoming Events",
    openNow: "Open",
    closedNow: "Closed",
    opensAt: "Opens at",
    closesAt: "Closes at",
    opens: "Opens",
    getTicketsAndTable: "Tickets & Tables",
    getTicketsAndOption: "Tickets & Options",
    getOptionAndMenu: "Options & Menu",
    getTicket: "Get Tickets",
    getTableAndMenu: "Tables & Menu",
    call: "Call",
    getVoucher: "Get Vouchers",
    back: "Back",
    freeAccess: "FREE ACCESS",
    noTicket: "You don’t need a ticket to attend",
    noPublishedTickets: "TICKETS ARE NOT FOR SALE YET",
    comeBack: "Try again later",
    addToCartSuccesss: "Tickets successfully added to cart!",
    comingSoon: "Coming Soon",
    soldOut: "Sold Out",
    tickets: "Tickets",
    vouchers: "Vouchers",
    organizer: "Organizer",
    gallery: "Gallery",
    overview: "Overview",
    priceRange: "Price Range",
    viewMenu: "View Menu",
    viewTickets: "Tickets",
    viewBooking: "Booking",
    reserveTable: "Reserve Table",
    reserve: "Reserve",
    dialogTitle: "You have a ticket to another event in cart",
    dialogAction: "Go to checkout",
    dialogContent:
      "If you want to buy a ticket to this event, you must first finish the checkout process for the one that is already in cart",
    typeOfTicket: "Type of Ticket",
    onlyinApp: "only available in app",
    redeem: "Redeem in app",
    typeOfTicketError: "Problem validating the ticket! Please reload the page.",
    addToCart: "Add To Cart",
    update: "Update",
    quantity: "Quantity",
    buyNow: "Buy",
    addedToCart: "Added to cart",
    chooseSeats: "Choose seats",
    chooseTickets: "Back to tickets",
    organizerEmail: "Organizer Email",
    organizerPhone: "Organizer Phone",
    DatabaseError:
      "Problem communicating with the database! Please try again later.",
    genericError: "A problem occurred! Please try again later.",
    continue: "Continue",
    itemsInYourCartTitle: "There are items in your cart",
    itemsInYourCartDescription:
      "To continue with your current selection, we'll have to remove your existing cart items.",
    cancel: "Cancel",
  },

  verifyCode: {
    errorVerifying: "Error while verifying!",
    successfulVerifying: "Verify success!",
    codeRequired: "Code is required",
    verify: "Verify",
  },

  landingPage: {
    title: "Your nightlife journey starts with",
    subTitle1: "Nightz is a dynamic and immersive social platform designed",
    subTitle2: "to elevate your event discovery and planning experience.",
    events: "Events",
    business: "Business",
    signIn: "Sign In",
    signUp: "Sign Up",
    home: "Home",
    allRightsReserved: "All rights reserved",
    madeBy: "made by",
    logout: "Logout",
    logoutError: "A problem occurred while logging out! Please try again.",
  },
  landingPageV2: {
    become_partner_button: "Get Started",
    become_partner_title: "BECOME A PARTNER",
    become_partner_description:
      " Are you a venue owner or event organizer? Create a business account and promote your activity in minutes.",
    trending_carousel_title: "TRENDING NOW",
    trending_carousel_description:
      "Explore the best activities recommended by Nightz.",
    trending_carousel_button: "Explore",
    friends_title: "FRIENDS",
    friends_description:
      "Nightz is the fastest & easiest way to hang out with your friends." +
      " We are all about real life socializing, that’s why we want you offline.\n",
    friends_button: "Hang Out",
    discover_title: "DISCOVER",
    discover_description:
      "We make the process of discovering the hottest events, coolest venues or finding something fun to do on" +
      "the weekend an enjoyable social experience.",
    discover_button: "Things to do",
    chat_and_plan_title: "CHAT & PLAN",
    chat_and_plan_description:
      "Talk to your friends, co-discover events and confirm attendance. " +
      "You can start your plan with an event or venue or start with a groupchat and decide what to do later",
    chat_and_plan_button: "Chat & Plan",
    stay_in_loop_title: "STAY IN THE LOOP",
    stay_in_loop_description_mobile:
      "Paint the town red, wherever you go. Find out who wants to hang out, and get curated recommendations based on location. Want to keep it quiet? Hide your profile.",
    stay_in_loop_description_web:
      "Paint the town red, wherever you go. Find out which friends want to hang out, if you are in the same city, and get your feed updated automatically with curated recommendations based on location. Want to keep it quiet? Hide your profile.",
    stay_in_loop_button: "Get Going",
    faster_easier_title: "FASTER, EASIER",
    faster_easier_description: "Discover activities, chat with friends and buy tickets: without links in bio and external sites. Everything you need, in one app, simple and fast. Because Nightz is about the destination, not the journey.",
    faster_easier_button: "Join Now",
    host_your_own_title: "HOST YOUR OWN",
    host_your_own_description: "Don't feel like going out? Gather your friends and plan something chill: a game night, a cabin, whatever comes to mind. Any friend can join the plan, but you must accept their request before they can see the full list of participants.",
    host_your_own_button: "Host"
  },
  businessPage: {
    showMore: "Show More",
    showLess: "Show Less",
    powerhouseTitle: "THE POWERHOUSE OF YOUR BUSINESS",
    powerhouseSubtitle: "We empower your restaurants and events with a seamless platform that fuels reservations and ticket sales, all while delivering the best experience to your clients.",
    powerhouseAction1: "Get started",
    powerhouseAction2: "Contact Sales",
    innovateTitle: "INNOVATE YOUR BUSINESS",
    innovateSubtitle: "We don't follow trends. We create them.",
    innovateCardTitle1: "Table reservations for events",
    innovateCardSubtitle1: "No more Excel spreadsheets and phone calls and last minute no-shows. Now you can sell tables and promo packages ahead of the event.",
    innovateCardAction1: "Try Now",
    innovateCardTitle2: "The first AI receptionist",
    innovateCardSubtitle2: "The AI employee that can take phone reservations and answer questions about your restaurant like a real person, even outside of business hours.",
    innovateCardAction2: "Call Allison",
    smartTicketingTitle: "SMARTER TICKETING, GREATER REACH",
    smartTicketingSubtitle: "Sell tickets with ease, grow your audience, and manage everything in one place.",
    smartTicketingAction: "Set up ticketing",
    fillTablesTitle: "FILL YOUR TABLES, STRESS-FREE",
    fillTablesSubtitle: "We automate reservations and give you the tools to manage guests and build loyalty effortlessly.",
    fillTablesAction: "Set up reservations",
    visibilityVelocityTitle: "TURN VISIBILITY INTO VELOCITY",
    visibilityVelocitySubtitle: "Nightz puts your business in front of the right audience — right when it matters.",
    visibilityVelocityAction: "Start analyzing",
    investmentTitle1: "NIGHTZ IS NOT A COST, ",
    investmentTitle2: "IT'S AN INVESTMENT",
    investmentSubtitle: "Forget about subscriptions. Only pay when you sell. We thrive when your business thrives, that's why we want to help you sell like crazy.",
    investmentAction: "Start Selling Like Crazy",
    investmentCardTitle1: "TICKETING",
    investmentCardValue1: "5% of all online ticket sales",
    investmentCardSubtitle1: "decreases with volume",
    investmentCardTitle2: "RESERVATIONS",
    investmentCardValue2: "5% of spending for our leads",
    investmentCardSubtitle2: "2.5% for your returning clients",
    pricesStartAt: "prices start at",
    ticketingSection: {
      tableTitle: "Ticketing Features",
      ticketingFeatures: {
        feature1: "Custom non-branded event page",
        description1: "Nightz is all about your event. That's why we keep our branding to a minimum.",
        feature2: "Unlimited events",
        description2: "Manage unlimited events from the same account.",
        feature3: "Unlimited tickets categories",
        description3: "Each category has its own unique serial number.",
        feature4: "Custom ticket design",
        description4: "Set custom colors for your ticket design.",
        feature5: "Early bird sales system",
        description5: "Generate ticket categories with increasing prices. Once the cheaper categories are sold out, the expensive ones get unlocked, one at a time.",
        feature6: "Group promotions",
        description6: "Nightz' innovation: Bulk discount that collects the data of all promotion participants, increasing the marketing userbase by 30% for each event.",
        feature7: "App promotions",
        description7: "Set lower ticketing prices in the mobile app, to build more loyalty for your audience with custom push notifications, ticket invites and discounts.",
        feature8: "Discount codes",
        description8: "Create discount codes for your loyal clients or in partnership with influencers.",
        feature9: "Ticket invites",
        description9: "Send ticket invites on email and in app to loyal customers. When they get invited, all their friends will be notified, resulting in more organic promotion for your business.",
        feature10: "Seating floorplans",
        description10: "Theaters, cinemas, conference rooms - we build any custom floorplan if your event requires seat booking.",
        feature11: "Live sales statistics",
        description11: "Start measuring revenue and identifying buyer trends as soon as your event is published.",
        feature12: "Live marketing statistics",
        description12: "Identify main lead generation channels and analyze the ROI of your marketing campaigns using custom links.",
        feature13: "Scanner in mobile app",
        description13: "Scan tickets directly from the mobile app, using an unlimited number of devices.",
        feature14: "Automated tax collection and payment",
        description14: "If enabled, this option allows us to take care of the entire govt. bureaucracy and taxes in different markets across Europe. You can sell stress free.",
        feature15: "Automated weekly payouts",
        description15: "Payouts happens every Monday, but earlier payouts are available for a flat fee of $5 per transaction.",
        feature16: "Multiple employee accounts",
        description16: "Create and control all your employees accounts in one place. Their only available features are to scan tickets and manage reservations. Restrict them once they no longer need access.",
      }
    },
    reservationsSection: {
      tableTitle: "Reservation features",
      reservationsFeatures: {
        feature1: "Custom non-branded venue page",
        description1: "Nightz is all about your restaurant. That's why we keep our branding to a minimum.",
        feature2: "Unlimited venues",
        description2: "Manage unlimited venues from the same account.",
        feature3: "Booking widget in your own website",
        description3: "Implement our booking widget with a low-code solution on any website in less than 5 minutes.",
        feature4: "Live 24/7 bookings",
        description4: "Get bookings anytime, even outside of opening hours.",
        feature5: "Live master calendar",
        description5: "View, add and modify all bookings in a single place. All changes appear instantly.",
        feature6: "Automated or manual confirmation",
        description6: "Enable automated confirmation to make the reservations process instantaneous for customers or keep manual confirmation for more control.",
        feature7: "Instant notifications",
        description7: "On Email/SMS and in the mobile app for reservation requests and updates.",
        feature8: "Smart assign",
        description8: "Automatically assign reservations to tables to maximize venue occupancy. Never overbook.",
        feature9: "Mobile/tablet app for reservations management",
        description9: "Use the mobile app to receive push notifications when reservations are added or cancelled. Manage all your bookings from the master calendar from an unlimited number of devices.",
        feature10: "Guest fidelity",
        description10: "Get informed on user loyalty based on the number of bookings created by a customer.",
        feature11: "Custom booking setup",
        description11: "Define custom opening hours, minimum and maximum booking lengths.",
        feature12: "Custom zone setup",
        description12: "Define separate bookable zones and tables in your venue (ex: rooftop, garden, saloon etc.)",
        feature13: "Custom table setup",
        description13: "Define individual tables to match your venue's layout. Set custom capacity and booking deposit.",
        feature14: "Booking deposits",
        description14: "Set a booking deposit to eliminate no-shows and increase profitability. Set the deposit at venue-level or choose custom prices depending on the zone or table size.",
        feature15: "Menu pre-order",
        description15: "Enable free or paid menu ore-orders, to make the dining process faster and seamless for customers and improve your cash flow. Automated payouts are made daily.",
        feature16: "Order management",
        description16: "View all items pre-ordered by users.",
        feature17: "Live reservation statistics",
        description17: "Identify reservation trends for the current day, week or month, to identify opportunities to improve your restaurant's occupancy.",
        feature18: "Live marketing statistics",
        description18: "Identify main lead generation channels and analyze the ROI of your marketing campaigns using custom links.",
        feature19: "POS Integration",
        description19: "Track user spending, identify high value clients and optimize table profitability. ",
        feature20: "Multiple employee accounts",
        description20: "Create and control all your employees accounts in one place. Their only available features are to scan tickets and manage reservations. Restrict them once they no longer need access.",
        feature21: "Real-time guest spend alerts",
        description21: "Get notified when a high-value guest spends over a certain threshold with your venue. Use this data to show appreciation, give out promotions and build up customer loyalty.",
        feature22: "Filtered reviews",
        description22: "We hate fake reviews as much as you do. That's why we set a minimum table spend consumers have to reach before they can leave a review.",
        feature23: "Guest tags",
        description23: "Assign tags to guests to identify VIP clients, regulars, good and bad behaving customers, as well as allergies or preferences.",
        feature24: "Reservation waitlist",
        description24: "Waitlists allow customers to line up for a table when your venue is full. They get notified via SMS/Email or app as soon as a table becomes available again.",
        feature25: "Customizable floor plans",
        description25: "We help you build floorplans according to your venue's setup, in order to view, manage, merge and assign reservations to tables easier.",
        feature26: "The AI Receptionist",
        description26: "Forget about phone calls, our AI employee can take phone reservations and answer questions about your restaurant or current promotions like a real person, even outside of business hours. You can customize everything from the name to the voice of your new employee. ",
      }
    },
    marketingSection: {
      tableTitle: "Marketing features",
      marketingFeatures: {
        feature1: "Free publishing on website and app",
        description1: "Nightz is designed for all savvy urban enthusiasts out there, creating a great opportunity to promote your business to a new audience of high-value customers.",
        feature2: "Regional/national promotion",
        description2: "Expand your visibility to nearby regions or nationwide with Nightz's trending category, to gain new clients. For best results, the minimum promotion duration is a week and the pricing depends on the number of regions covered.",
        feature3: "Performance-based promotion",
        description3: "Well-performing businesses are automatically pushed in the top 10 experiences in every city. The rank is updated weekly, based on the number of tickets and reservations booked.",
        feature4: "Sales channels insights",
        description4: "Identify the most profitable lead generation channels that bring the most high-value clients. Compare this data against your competitors to identify areas of improvement.",
        feature5: "Demographic insights",
        description5: "We use advances analytics tools, compliant with the latest GDPR policies, in order to consolidate the demographics of your audience. This can help you better understand who is your main audience, identify underserved audiences and create better business strategies.",
        feature6: "Custom campaigns",
        description6: "Send app notifications, email campaigns or SMS blasts to your customers to keep them engaged with your business. Fees vary depending on campaign type and volumes.",
      }
    }
  },

  categories: {
    event: "Event",
    theatre: "Theatre",
    experience: "Experience",
    restaurant: "Restaurant",
    custom: "Custom",
    Chill: "Chill",
    conference: "Conference",
    landmark: "Landmark",
    bar: "Bar",
    coffeeShop: "Coffee Shop",
    Revelion: "New Year's Eve",
    Concert: "Concert",
    Culture: "Culture",
    Club: "Club",
    Festival: "Festival",
    SportEvent: "Sport Event",
    headingSubcategoryNightz: "Choose one of the Nightz options",
    headingSubcategoryDayz: "Choose one of the Dayz options",
    headingCategory: "What activity does your activity fit in?",
    backToMyListings: "Back to My Listings",
  },

  platformSettings: {
    title: "Platform Settings",
    subtitle: "Admin Interface",
  },

  voucherGeneration: {
    title: "Voucher Generation",
    subtitle: "Generate vouchers that users can apply in their checkout.",
    form: {
      voucherTitle: "Voucher Title",
      userEmail: "User Email",
      applicableListing: "Applicable Listing",
      expiryDate: "Expiry Date",
      discountType: "Discount Type",
      discountAmount: "Discount Amount",
      maxUsage: "Max usage (Total)",
      maxUsagePerListing: "Max Usage Per Listing",
      percent: "Percentage (%)",
      fixed: "Fixed Value",
      multiple: "Percentages (%)",
      applicableToAll: "Applicable to all listings",
      uploadDoc: "Upload accomodation proof document",
      or: "OR"
    },
    action: "Generate Voucher",
    success: "Voucher created successfully!",
    error: "Voucher creation failed. ",
    generatedVouchers: "Vouchers",
    generatedVouchersSubtitle: "View details about generated vouchers and their usages."
  },
  voucherValidation: {
    title: "Voucher Validation",
    subtitle: "Validate and apply vouchers for your shop.",
    code: "Voucher code",
    validate: "Validate",
    instructions: "Insert the voucher code to validate it and to apply the discount for your shop",
    instructions2: "Select the event and insert the voucher code to validate it and to apply the discount",
    success: "Voucher applied successfully!",
    name: "Name",
    codeShort: 'Code',
    expiry: "Expires",
  },
  vouchersTable: {
    firstName: "First Name",
    lastName: "Last Name",
    phone: "Phone",
    email: "Email",
    voucherCode: "Voucher Code",
    generatedBy: "Generated by",
    accomodationInvoice: "Accommodation Proof",
    availability: "Availability",
    usage: "Usage"
  },

  companiesList: {
    title: "Companies list",
    subtitle: "Admin Interface",
    view: "View",
    edit: "Switch for editing fields",
    save: "Save",
    download: "Download table",
    searchNamePlaceholder: "Search Owner name, email ore phone...",
    tableHeader: {
      name: "Name",
      emailAccount: "Email Account",
      phoneAccount: "Phone Account",
      company: "Company",
      cui: "TIN/FEIN",
      cuiPopover:
        "Tax Identification Number/Federal Employer Identification Number",
      documents: "Documents",
      status: "Status",
    },
    statusTypes: {
      pending: "Pending",
      banned: "Banned",
      approved: "Accepted",
      selfManaged: "Self managed",
      draft: "Draft",
    },
    tableCellPopover: {
      all: "All documents uploaded",
      mandatory: "Only the registration certificate and b2b Contract uploaded",
      notMandatory:
        "The registration certificate and b2b Contract have not been uploaded yet",
    },
    registerForm: {
      title: "Company account approval",
      description:
        "Check all the company information and set the ticketing commission according to the contract.",
      status: "Company status",
      commissionTickets: "Commission for tickets",
      commissionBooking: "Commission for reservations",
      commissionPaidByUser: "Commission paid by"
    },
    errorMessages: {
      required: "This field is required",
      min: "Commission must be greater than or equal to 0",
      max: "Commission must be less than or equal to 100",
    },
  },

  transactionTab: {
    excelOptions: {
      ordersOnly: "Transactions",
      ticketsAndOrders: "Transactions and Items",
    },
  },
  campaigns: {
    campaignsTitle: "Campaigns",
    createCampaign: "Create Campaign",
    campaignsSubtitle: "Create and send SMS, email or notification campaigns",
    campaignsTableSubtitle: "View details about previously created campaigns",
    campaignType: "Campaign Type",
    message: "Message",
    recipients: "Recipients",
    sms: "SMS",
    email: "Email",
    notification: "Push Notifications",
    link: "Link URL",
    send: "Send",
    success: "Campaign created successfully!",
    error: "Error creating campaign",
    estimatedCost: "Estimated cost",
    unsubscribePrompt: "Click here to unsubscribe from marketing campaigns.",
    unsubscribeSuccess: "You have unsubscribed successfully!",
    unsubscribe: "Unsubscribe",
    emptyTitle: "No campaigns",
    emptySubtitle: "Once a campaign is created, it will appear here.",
    messagePreview: "Message preview",
    selectRecipients: "Select Recipients"
  },
  campaignsTable: {
    createdAt: "Created At",
    type: "Type",
    status: "Status",
    title: "Title",
    message: "Message",
    link: "Link",
    linkClicks: "Link Clicks",
    totalCount: "Recipients",
    sentCount: "Sent",
    failedCount: "Failed",
  },

  eventManager: {
    sellStartDate: "Sale Start Date",
    sellEndDate: "Sale End Date",
    addModule: "Add Module",
    statusTypes: {
      created: "Created",
      draft: "Draft",
      ready: "Ready",
      pending: "Pending",
      ongoing: "Ongoing",
      expired: "Expired",
      deleted: "Deleted",
      cancelled: "Cancelled",
      waitingForPayment: "Waiting for payment",
    },
    seats: {
      send: "Send",
      cancel: "Cancel",
      sendTicketInvite: "Send Ticket Invite",
      ticketInvite: "Ticket Invite",
      printTickets: "Print Tickets",
      eventId: "Event ID:",
      selectedSeats: "Selected seats",
      numberOfTickets: "Number of tickets",
      name: "Name",
      emailAddress: "Email address",
      printer: "Printer",
      printerNotSelected: "Printer not selected",
      qzNotRunning: "QZ not running",
      noSeatsSelected: "No seats selected!",
      printSuccess: "Tickets printed successfully!",
      printedTicket: "Printed Ticket"
    },
    title: {
      newEvent: "Create a New Listing",
      editEvent: "Edit",
    },
    notApprovedDurationTitle: "Action required:",
    notApprovedDurationBody:
      "You need to cancel all active reservations before you can change the date of the event.",
    notApprovedDurationButton: "OK",
    modulesSummary: {
      endTimeError: "End time is earlier than start time",
      settingsTitle: "Admin Settings",
      settingsDescription:
        "Control the the main characteristics of the event, such as category, tags, status and visibility.",
      durationTitle: "Duration",
      durationDescription:
        "Tell people when your event starts and ends or whether your services are available permanently.",
      generalDetailsTitle: "General Details",
      generalDetailsDescription:
        "Name your event or venue, set the main cover image and tell a story to your audience.",
      locationTitle: "Location",
      locationDescription:
        "Let people know where your event or venue is located, and get discovered by people in the area.",
      ratingTitle: "Rating",
      ratingDescription: "Set up other links associated with your listing",
      contactTitle: "Contact Details",
      contactDescription:
        "Set up your social links as well as methods people can get in touch with you.",
      imageGalleryTitle: "Image Gallery",
      imageGalleryDescription:
        "Create a visual impact by adding stunning pictures of your products or services.",
      ticketingTitle: "Ticketing",
      ticketingDescription:
        "Set up custom free or paid tickets, add promo codes and send invites for your event.",
      openingHoursTitle: "Opening Hours",
      openingHoursDescription:
        "Inform customers about the opening and closing time.",
      reservationsTitle: "Reservations",
      reservationsDescription:
        "Define bookable spaces within your venue and start managing reservations instantly.",
      reservationsMenuTitle: "Menu Reservations",
      reservationsMenuDescription: "Define menus for bookings",
    },
    warningDeleteModal: {
      standardWarningDeleteTitle: "Deleting Module",
      standardWarningDeleteMessage:
        "Are you sure do you want to delete this module and all of the data associated with it?",
    },
    nameLabel: "Name",
    priceLabel: "Price",
    tableTitle: "Areas",
    addArea: "Add Area",
    tableTitleCategory: "Categories",
    addCategory: "Add Category",
    editOption: "Edit",
    deleteOption: "Delete",
    editModalNewAreaTitle: "Add new area",
    editModalExistingAreaTitle: "Edit Area",
    editModalNameLabel: "Name of your area",
    editModalPriceLabel: "Price of the area",
    editModalNewCategoryTitle: "Add new category",
    editModalExistingCategoryTitle: "Edit category",
    editModalCategoryNameLabel: "Name of your category",
    editModalCategoryPriceLabel: "Price of the category",
    forbiddenDeleteAreaDialogTitle: "Error",
    forbiddenDeleteAreaDialogDescription:
      "This area can't be deleted as there are tables that belong to it. " +
      "Please first delete those tables and then you can proceed with deleting this area.",
    forbiddenDeletCategoryDialogDescription:
      "This category can't be deleted as there are options that belong to it. " +
      "Please first delete those options and then you can proceed with deleting this category.",
    forbiddenDeleteTableDialogDescription:
      "This table can't be deleted as there are upcoming reservations that belong to it. " +
      "Please first delete those reservations and then you can proceed with deleting this table.",
    forbiddenDeleteOptionDialogDescription:
      "This option can't be deleted as there are upcoming reservations that belong to it. " +
      "Please first delete those reservations and then you can proceed with deleting this option.",
    noAreaTitle: "The reservation module is empty!",
    noAreaBody:
      "Please add areas and tables or remove the module in order to publish the activity.",
    noCategoryBody:
      "Please add categories and options or remove the module in order to publish the activity.",
    noAreaButton: "Ok",
    spaces: {
      nameLabel: "Name",
      areaLabel: "Area",
      categoryLabel: "Category",
      capacityLabel: "Capacity",
      tableTitle: "Tables",
      addSpace: "Add Table",
      optionTitle: "Options",
      addOption: "Add Option",
      addSpaces: "Add Multiple",
      addMultipleModalConfirm: "Add Tables",
      addMultipleModalTitle: "Add multiple tables at once",
      addMultipleModalDescription: "Please use the Excel Template and complete all the details in order to add tables in bulk.",
      addMultipleOptionsModalConfirm: "Add Options",
      addMultipleOptionsModalTitle: "Add multiple options at once",
      addMultipleOptionsModalDescription: "Please use the Excel Template and complete all the details in order to add options in bulk.",
      editOption: "Edit",
      deleteOption: "Delete",
      editModalNewSpaceTitle: "Add a new table",
      editModalExistingSpaceTitle: "Edit Table",
      editModalNameLabel: "Name of the table",
      editModalCapacityLabel: "Capacity of the table",
      editModalPriceLabel: "Price of the table",
      editModalNewOptionTitle: "Add a new option",
      editModalExistingOptionTitle: "Edit option",
      editModalOptionNameLabel: "Name of the option",
      editModalOptionCapacityLabel: "Capacity of the option",
      editModalOptionPriceLabel: "Price of the option",
      noAreasModalTitle: "No area has been found",
      noCategoriesModalTitle: "No category has been found",

      priceError: "Price must be greater or equal to 0",
      capacityError: "Capacity must be greater or equal to 0",
      nameError: "Name is required",
      noAreasModalDescription:
        "No area has been created that your table can belong to. Please first add at least one area.",
      noCategoriesModalDescription:
        "No category has been created that your option can belong to. Please first add at least one category.",
    },
    menus: {
      vat: "VAT",
      tableTitle: "Menus",
      nameLabel: "Name",
      categoryLabel: "Category",
      priceLabel: "Price",
      quantityLabel: "Quantity",
      addMenu: "Add Menu",
      addMenus: "Add Multiple",
      addMultipleModalConfirm: "Add Menus",
      addMultipleModalTitle: "Add multiple menu items at once",
      addMultipleModalDescription: "Please use the Excel Template and complete all the details in order to add menus in bulk.",
      editOption: "Edit",
      deleteOption: "Delete",
      editModalNewMenuTitle: "Add a new Menu",
      editModalExistingMenuTitle: "Edit Menu",
      editModalNameLabel: "Name",
      editModalCategoryLabel: "Category",
      editModalPriceLabel: "Price",
      editModalQuantityLabel: "Quantity",
      editModalMetricLabel: "Metric",
      category: {
        APPETIZERS: "Appetizers",
        BREAKFAST: "Breakfast",
        SPECIALS: "Chef's Specials",
        SOUPS: "Soups",
        SALADS: "Salads",
        MAIN_COURSE: "Main Course",
        SIDES: "Sides",
        PASTA_RISOTTO: "Pasta & Risotto",
        PIZZA: "Pizza",
        FLATBREAD: "Flatbreads",
        BURGERS: "Burgers",
        FISH: "Fish",
        SEAFOOD: "Seafood",
        GRILL: "Grill",
        CHICKEN: "Chicken Specialties",
        PORK: "Pork Specialties",
        BEEF: "Beef Specialties",
        PLATTER: "Platters",
        VEGETARIAN_VEGAN: "Vegetarian / Vegan Options",
        SNACKS: "Snacks",
        SAUCES: "Sauces",
        DESSERTS: "Desserts",
        PROMOTIONAL_PACKAGES: "Promotional Packages",
        SOFT_DRINKS: "Soft Drinks",
        JUICES_SMOOTHIES: "Juices & Smoothies",
        TEA_COFFEE: "Tea & Coffee",
        BEER: "Beer",
        ALCOHOLIC_COCKTAIL: "Cocktails",
        NON_ALCOHOLIC_COCKTAIL: "Non-Alcoholic Cocktails",
        WINES: "Wines",
        WINES_GLASSES: "Wines by the Glass",
        WINE_BOTTLES: "Wines by the Bottle",
        SPARKLING_WINES: "Sparkling Wines",
        VODKA: "Vodka",
        TEQUILA: "Tequila",
        GIN: "Gin",
        WHISKEY: "Whiskey",
        COGNAC: "Cognac",
        LIQUOUR: "Liquour",
        PALINCA: "Palinca",
        SHOTS: "Shots",
        CIGARETTES: "Cigarettes",
      },
      quantityMetric: {
        GRAM: "g",
        KILOGRAM: "kg",
        MILLILITER: "ml",
        LITER: "l",
        PIECE: "pcs",
        SLICE: "slice",
        CUP: "cup",
        BOWL: "bowl",
        PLATE: "plate",
        BOTTLE: "bottle",
        GLASS: "glass",
        SHOT: "shot",
        PINT: "pint",
        HALF_PINT: "half pint"
      },
    },
    bookingSettings: {
      cardLabel: "Reservation Settings",
      menuCardLabel: "Menu Settings",
      menuSettingsDescription: "If this option is disabled, the menu is only displayed for informational purposes. Enable it to allow pre-ordering of menu items.",
      bookingIntervalLabel: "Booking Interval",
      bookingDurationLabel: "Booking Duration (in minutes)",
      automaticConfirmationLabel: "Automatic Confirmation of a booking",
      enabledMenuPurchaseLabel: "Menu purchase enabled",
      enabledSpecialRequirementsLabel: "Booking special requirements enabled",
      enabledHoldingFeePerPersonLabel: "Holding fee per person enabled",
      isBookableUnitLabel: "Replace areas and tables with categories and bookable options",
      holdingFeeLabel: "Holding fee when booking",
      bookingIntervalPart1: "Every",
      bookingIntervalPart2: "minutes",
      minGuests: "Min guests option",
      maxGuests: "Max guests option",
      minBookingGuests: "Min guests to book",
      maxBookingGuests: "Max guests to book"
    },
    sessions: {
      all: "All",
      session: "Session",
      addSession: "Add Session",
      addMultiple: "Add Multiple",
      defineYourSessions: "Define Your Sessions",
      generateSessions: "Generate Sessions",
      editSession: "Edit Session",
      title: "Title",
      capacity: "Available Tickets Total",
      startDate: "Start Time",
      endDate: "End Time",
      ticketTypes: "Ticket Types",
      eventKey: "Seats.io Event Key",
      addSingle: "Add Single Session",
      addMultipleSessions: "Add Multiple Sessions",
      sessionDetails: "Session Details",
      dateRange: "Date Range",
      bookTickets: "Book Tickets",
      bookTicketsLong: "Book Tickets",
      hold: "On Hold",
      available: "Available",
      saveEventFirst: "Please save your event first!",
      for: "for",
      delete: "Delete Session",
      copyPrevious: "Copy previous day"
    },
    embedIframe: {
      title: "Embed Iframe",
      descriptionPart1:
        "To implement the reservations system in your website, you can use the generator below, which will create an Iframe with the specified width and height values. If you need assistance, don't hesitate to ",
      descriptionV2:
        "To implement the system in your website, you can use the generator below, which will create an Iframe with your event link and the specified height value. If you need assistance, don't hesitate to ",
      descriptionPart2: "contact us.",
      width: "Width (px)",
      height: "Height (px)",
      submit: "Generate",
      copyText: "Copy code",
      copySuccess: "Iframe copied to clipboard",
      copyFailure: "Failed to copy iframe to clipboard",
      theme: "Theme",
      darkLabel: "Dark",
      lightLabel: "Light",
    },
    closeCurrentDay: "Opened now!   Mark this day as closed.",
    openCurrentDay: "Closed now!   Mark this day as opened.",
    toggleModuleTrue: "ENABLED",
    toggleModuleFalse: "DISABLED",
    listing: "Listing",
    listings: "My listings",
    seasonPassNoListings: "There are no listings in the interval defined by this season pass",
    business: "My business",
    delete: "Delete",
    deleteMessage: "Are you sure you want to delete",
    items: "items",
    item: "item",
    edit: "Edit",
    duplicate: "Duplicate",
    selected: "selected",
    new: "New listing",
    clear: "Clear selection",
    entryType: "Type of the entry",
    free: "Free",
    ticket: "Ticket",
    ditlReport: "DITL Report",
    ditlReportQuestion: "Do you want to report info to DITL?",
    yes: "I want",
    no: "I don't want",
    subcategory: "Subcategory",
    subcategories: {
      Event: "Event",
      Restaurant: "Restaurant",
      CoffeeShop: "Coffee shop",
      Experience: "Experience",
      Landmark: "Landmark",
      Chill: "Chill",
      Bar: "Bar",
      NewYearsParty: "New Year's party",
      Concert: "Concert",
      Culture: "Culture",
      Club: "Club",
      Festival: "Festival",
      SportEvent: "Sport event",
      Conference: "Conference",
      OutdoorActivity: "Outdoor activity",
      Beach: "Beach",
      HikingTrail: "Hiking trail",
      SkiResort: "Ski resort",
      Museum: "Museum",
      StandUp: "Stand Up",
      Volunteering: "volunteering"
    },
    subcategoriesPlural: {
      Event: "Events",
      Restaurant: "Restaurants",
      CoffeeShop: "Coffee shops",
      Experience: "Experiences",
      Landmark: "Landmarks",
      Chill: "Chill",
      Bar: "Bars",
      NewYearsParty: "New Year's Eve",
      Concert: "Concerts",
      Culture: "Culture",
      Club: "Clubs",
      Festival: "Festivals",
      SportEvent: "Sport events",
      Conference: "Conferences",
      OutdoorActivity: "Outdoor activities",
      Beach: "Beaches",
      HikingTrail: "Hiking trails",
      SkiResort: "Ski resorts",
      Museum: "Museums",
      StandUp: "Stand Up",
      Volunteering: "volunteering"
    },
    bookLink: "Booking Link",
    menuLink: "Menu Link",
    noVisibleticketsError: "At least one ticket needs to be visible!",
    eventName: "Event name",
    description: "Description",
    writeSomethingAwesome: "Write something awesome...",
    nightzComissionTicket: "Nightz commission for tickets",
    nightzComissionTicketText: "The commission that Nightz will take from the event for ticket sales",
    nightzComissionBooking: "Nightz commission for reservations",
    nightzComissionBookingText: "The commission that Nightz will take from the event for reservations",
    mainImage: "Main Image of the event",
    mainImageMobile: "Trending Image Background Mobile",
    mainImageWeb: "Trending Image Background Web",
    images: "Images",
    useImagesModuleEnable: "Add more images to your post",
    useImagesModuleDisable: "Remove option to have more images to your post. ",
    deleteOpeningHoursModuleTitle: "Delete Opening Hours Module",
    deleteOpeningHoursModuleDescription:
      "Do you want to delete the Opening Hours Module?",
    createOpeningHoursModuleTitle: "Add Opening Hours Module",
    createOpeningHoursModuleDescription:
      "Are you sure that you want to add the Opening Hours Module, so that you can personalize the schedule of your listing? ",
    deleteReservationsModuleTitle: "Delete Reservations Module",
    deleteReservationsModuleDescription:
      "Do you want to delete the Reservations Module? If you proceed, all data associated with this module will be deleted.",
    createReservationsModuleTitle: "Add Reservations Module",
    createReservationsModuleDescription:
      "Are you sure that you want to add the Reservations Module, so that you can manage bookings at your location? ",
    useOpeningHoursModuleEnable:
      "Add opening hours module. This module let's you personalize the opening hours " +
      "of your listing depending on the day of the week",
    useOpeningHoursModuleDisable: "Remove the opening hours module.",
    useReservationsModuleEnable:
      "Add reservations module. This module allows you to receive bookings at your location. Requires permanent or one-time event.",
    useReservationsModuleDisable: "Disable the reservations module",

    deleteReservationsMenuModuleTitle: "Delete Reservations Menu Module",
    deleteReservationsMenuModuleDescription:
      "Do you want to delete the Reservations Menu Module?",
    createReservationsMenuModuleTitle: "Add Reservations Menu Module",
    createReservationsMenuModuleDescription:
      "Are you sure that you want to add the Reservations Menu Module, so that you can manage menu bookings at your location? ",
    useReservationsMenuModuleEnable:
      "Add Reservations Menu Module. This module allows you to receive bookings with menus at your location. Requires reservations module.",
    useReservationsMenuModuleDisable: "Disable the Reservations Menu Module",

    useTicketsModuleEnable: "Add tickets module to your post",
    useTicketsModuleDisable: "Remove tickets module from your post. ",
    forbiddenDeleteTicketsModuleModalTitle: "Deleting Ticketing Module",
    forbiddenDeleteTicketsModuleModalDesc:
      "This module cannot be deleted because the ticket sale has already started." +
      " To delete this module please contact an Account Manager, because you need to " +
      "refund the sold tickets first.",
    allowedDeleteTicketsModuleModalDesc:
      "Deleting this module will delete all the ticket categories created. " +
      "Continue deleting the module?",
    normalTickets: "Normal Tickets",
    vouchers: "Vouchers",
    earlyBirdTickets: "Early Bird Tickets",
    name: "Name",
    percent: "Percent",
    promoCodes: "Promo Codes",
    ticketSubcategories: "Ticket categories",
    serialNumber: "Serial Number",
    initialTickets: "Initial Tickets",
    remainingTickets: "Remaining Tickets",
    ticketsModule: "Tickets Module",
    ticketDesign: "Ticket design",
    ticketImage: "Ticket Image",
    ticketSettings: "Ticket settings",
    maxCartTicketQuantity: "Max. cart ticket quantity",
    displayedPrice: "Displayed price",
    addTicket: "Add Ticket",
    addVoucher: "Add Voucher",
    eventKey: "Seating map",
    eventKeyKey: "Seating map key",
    mapContactUs1: "Allow attendees to choose their seats with our interactive seating maps, powered by a world-class solution used by top stadiums and theatres. ",
    mapContactUs2: " and we will build a custom map for your event!",
    mapContactUs: "Contact us",
    tooManySeats: "You can only sent ticket invites for up to 10 seats at once",
    editTicket: {
      ticketName: "Name of the ticket",
      voucherName: "Name of the voucher",
      numberOfAvailableTickets: "Number of available tickets",
      numberOfAvailableVouchers: "Number of available vouchers",
      priceReportDITL: "Price reported to DITL",
      priceCashout: "Desired revenue",
      displayedPrice: "Displayed price",
      ticketPrice: "Ticket price",
      commisionNightz: "Nightz Commission",
      paidByCompany: "Paid by your company",
      paidByBuyer: "Paid by the buyer",
      commisionDitl: "Ditl Tax",
      valueNightzTva: "Nightz VAT Value",
      valueClientTva: "Company VAT Value",
      invoiceToNightz: "Value Invoiced to Nightz",
      ticketDescription: "Description of the ticket",
      addTicket: "Add Ticket",
      addVoucher: "Add Voucher",
      saveTicket: "Save",
      participants: "Participants",
      discountPerPerson: "Discount per person (%)",
      price: "Price per person",
      ticketPromotionType: "Ticket Promotion Type",
      noPromotion: "No Promotion",
      appOnlyPromotion: "App only Promotions",
      tierPromotion: "Tier Promotion",
      normalPrice: "Normal Price",
      editTicket: "Edit Ticket",
      addNewTicket: "Add New Ticket",
      cancel: "Cancel",
      selectSessionsManually: "Select Sessions Manually",
      addAllSessions: "Add All Sessions",
      eventSessions: "Event Sessions",
      errors: {
        ticketNumberRequired: "Number of tickets required",
        ticketNumberMin: "Number of tickets must be greater than 0",
        ticketNumberMax: "Number of tickets must not be greater than 10",
        ticketNumberInteger: "Total must be an integer",
        ticketPriceRequired: "Price per tickets required",
        ticketPriceDitlRequired: "Price per tickets required",
        ticketNameRequired: "Name is required",
        ticketValueNumber: "Value must be a number",
        ticketPromotionParticipantValue: "Participants required",
        ticketPromotionPriceValue: "Price required",
        ticketPromotionLowerParticipantLimit:
          "Participants must be greater than 1",
        ticketPromotionParticipantLimit:
          "Participants must be greater than previous tier",
        ticketPromotionPriceLimit: "Price must be lower than previous tier",
        ticketPromotionDefaultPriceLimit: "Price must be lower than default price",
        ticketPromoPriceRequired: "Promo price is required",
        maxPercentage: "The percentage can't be higher than 100%",
        nrPercentageRequired: "The percentage is required",
        minNrPercentage: "The minimum percentage number must be greater than 1",
        maxNrPercentage: "Number must be smaller than 100.",
      },
      info: {
        ticketPrice: "Please first enter ticket price",
      },
    },
    editPromoCode: {
      addNewPromoCode: "Add New Promo Code",
      editPromoCode: "Edit Promo Code",
      name: "Promo Code",
      percent: "Discount Percent",
      addPromoCode: "Add Promo Code",
    },
    editTicketSubcategory: {
      addNewTicketSubcategory: "Add New Ticket Category",
      editTicketSubcategory: "Edit Ticket Category",
      name: "Ticket Category",
      addTicketSubcategory: "Add Ticket Category",
    },
    invite: {
      send: "Send",
      title: "Invite your friends",
      name: "Name",
      email: "Email address",
      quantity: "Tickets number",
      success: "Invitations have been sent successfully",
      validation: {
        quantityRequired: "Tickets quantity is required",
        quantityAvailable: "Invalid quantity.",
        quantityDigits: "Quantity must contain onyl digits",
        nameRequired: "Name is required",
      },
    },
    category: "Category",
    insights: "Insights",
    typesOfMusic: "Types of music",
    dateAndTimeInfo: "Date and time information",
    opening: "Start time",
    closing: "End time",
    startDate: "Start time of the event",
    endDate: "End time of the event",
    contactInfo: "Contact information",
    venueInfo: "Informațions about the restaurant",
    facebook: "Your facebook profile",
    instagram: "Your instagram profile",
    tiktok: "Your tiktok profile",
    organizerWebsite: "Link to your website",
    organizerEmail: "Organizer email",
    venueEmail: "Organizer email",
    organizerPhone: "Organizer phone number",
    twilioPhone: "Twilio Phone",
    organizerDisplayName: "Organizer displayed name",
    tags: "Tags",
    currency: "Currency",
    ticketTypes: "Ticket Types",
    legalName: "Legal name of the organizer",
    cuiOrganizer: "CUI of the organizer",
    street: "Street and number",
    visibility: "Visibility of the event",
    locationVenue: "Venue",
    countyVisibility: "County visibility",
    city: "City",
    county: "County",
    venueName: "Name of the location",
    displayName: "Name of the location",
    status: "Status",
    isMainEvent: "Is Main Event?",
    isSeasonPassSale: "Is Season Pass Sale",
    isPermanent: "Event progress details",
    permanent: "Permanent post",
    oneTime: "One time event",
    recurring: "Recurring event",
    mainEventCountyVisibility: "County in which it is Main Event",
    addressLabel: "Event Address",
    googleLocationLink: "Google Maps link to the address",
    eventTickets: "Event tickets",
    downloadData: "Download data",
    downloadHere: "Download here.",
    documentProblem: "There is a problem with your document!",
    documentValid: "Your document is correct!",
    createData: "Create Product",
    saveChanges: "Save Changes",
    publishNow: "Publish now",
    publishing: "Publishing",
    isPublishedTrue: "Published",
    isPublishedFalse: "Unpublished",
    pendingButton: "Waiting for approval",
    unPublish: "Unpublish now",
    noTicketsSold: {
      title: "No tickets sold yet!",
      content:
        "Because no tickets were sold for this event, there is no data available to download.",
      understand: "I understand",
    },
    noTicket: "No items for this order",
    visibilityOptions: {
      web: "Just web",
      app: "Just app",
      web_and_app: "On web and app",
      link_only: "Link only"
    },
    yourEvents: "Your listings",
    allOfYourEvents: "All of your listings",
    addAPartyNow: "Add a listing now",
    borderColorTicket: "Border color of the ticket",
    trendingBg: "Trending Color",
    borderColorVoucher: "Border color of the voucher",

    tabs: {
      eventDetails: "Listing Details",
      transactions: "Transactions",
      taxReports: "Tax Reports",
      statistics: "Statistics",
      reservationsCalendar: "Reservations Calendar",
      reservationsTable: "Reservations Table",
      tickets: "Tickets",
      floorPlan: "Plan",
      seatingMap: "Seating Map",
      sessions: "Sessions",
      seasonPasses: "Season Passes"
    },
    companyNotApprovedTitle: "Please verify your company",
    companyNotApproved:
      "Your company is not verified yet. Please enter your company details and send them for approval. After your company is verified, you can start publishing.",
    companyPendingTitle: "Your company details are under review",
    companyPending:
      "Your company is not verified yet. Please wait for approval.",
    cancel: "Cancel",
    rating: "Rating",
    reviewsCount: "Reviews Count",
    priceRangeStart: "Price Range Start",
    priceRangeEnd: "Price Range End",
    program: "Program",
    eventEditor: {
      publishDialogTitle: "Are you sure you want to publish the event?",
      publishDialogContent:
        "You will no longer be able to change tickets after this action. Make sure you report the tickets to DITL. You can find the DITL form",
      publishDialogLink: "here",
      publishDialogAgreeButton: "Publish",
      publishDialogDisagreeButton: "Back",
    },
    strechToSeeMoreColumns:
      "You can see more columns if you use the strech property in the settings",
    floorPlan: {
      buildFirstTitle: "Build your first plan",
      buildFirstDescription: "Once you define all your areas and tables, you can start creating your plan.",
      buildFirstOptionsDescription: "Once you define all your booking categories and options, you can start creating your plan.",
      startBuilding: "Start Building",
      availableItems: "Available Items",
      addAll: "Add All",
      removeAll: "Remove All",
      exitEditor: "Exit Editor",
      saveChanges: "Save Changes",
      managementView: "Management View",
      customerView: "Customer View",
      select: "Select",
      draw: "Draw",
      reCenter: "Re-center",
      image: "Image",
      zoomIn: "Zoom In",
      zoomOut: "Zoom Out",
      text: "Text",
      editTitle: "Edit plan?",
      editContent: "We recommend doing this outside business hours."
    },
  },

  deleteEvent: {
    errorName: "You didn't enter the event name correctly",
    dialogTitle: "Delete this event?",
    dialogSubtitle: "Confirm you want to delete this event by typing",
    dialogSubtitleVariant1: "its name",
    dialogSubtitleVariant2: "this",
    dialogSubtitleVariant3:
      "This event can't be deleted because there are tickets have already been sold. " +
      "If you wish to hide this event from customers, please unpublish it and contact" +
      "the administrator if you need further guidance.",
  },

  duplicateListing: {
    dialogTitle: "Do you want to duplicate this listing?",
    dialogSubtitle:
      "A new listing will be created with draft status using the info of this post",
  },

  staticPages: {
    contactUs: {
      title: "Contact Us",
      pageTitle: "Contact details",
      workProgram: "Work program:",
      workProgramDetails:
        "Monday - Friday: 09:00 - 17:00 Weekends and public holidays: Closed",
      address: "Address(For correspondence):",
      addressDetails:
        "Sat Remetea Chioarului, Comuna Remetea Chioarului, Nr. 279, Județ Maramureș; Cod postal: 437230",
      phone: "Phone",
    },
    cookiesPolicy: {
      title: "Cookies Policy",
    },
    termsAndConditions: {
      title: "Terms and Conditions",
    },
    privacyPolicy: {
      title: "Privacy Policy",
    },
  },
  messages: {
    warnUserToSaveChanges:
      "For the photo to be saved as a profile photo, please press the 'Save Changes' button.",
    moduleCreatedSuccessfully: "Module Created Successfully",
    moduleCreatedError: "Error while creating the module",
    moduleDeletedSuccessfully: "Module deleted successfully",
    moduleDeletedError:
      "Error while deleting the module. Please first delete everything regarding the module",
    areaCreateSuccessfully: "Area has been successfully created",
    areaCreateError: "Error while creating the area",
    areaUpdatedSuccessfully: "Area has been successfully updated",
    areaUpdateError: "Error while updating the area",
    areaDeleteSuccessfully: "Area has been deleted successfully",
    areaDeleteError: "Error while deleting area.",
    spaceDeleteSuccessfully: "Table has been deleted successfully",
    spaceDeleteError: "Error while deleting table.",
    spaceCreateSuccessfully: "Table has been created successfully",
    spacesCreateSuccessfully: "Tables have been created successfully",
    spaceCreateError: "Error while creating table.",
    spacesCreateError: "Error while creating tables.",
    spaceUpdateSuccessfully: "Table has been updated successfully",
    spaceUpdateError: "Error while updating table.",
    categoryCreateSuccessfully: "Category has been successfully created",
    categoryCreateError: "Error while creating the category",
    categoryUpdatedSuccessfully: "Category has been successfully updated",
    categoryUpdateError: "Error while updating the category",
    categoryDeleteSuccessfully: "Category has been deleted successfully",
    categoryDeleteError: "Error while deleting category.",
    optionDeleteSuccessfully: "Table has been deleted successfully",
    optionDeleteError: "Error while deleting table.",
    optionCreateSuccessfully: "Table has been created successfully",
    optionsCreateSuccessfully: "Tables have been created successfully",
    optionCreateError: "Error while creating table.",
    optionsCreateError: "Error while creating tables.",
    optionUpdateSuccessfully: "Table has been updated successfully",
    optionUpdateError: "Error while updating table.",
    addToFloorPlan: "Make sure to add it to your floor plan!",
    addMultipleToFloorPlan: "Make sure to add them to your floor plan!",
    floorPlanIncomplete: "Your floor plans are incomplete. Make sure to add missing tables.",
    menuDeleteSuccessfully: "Menu item has been deleted successfully",
    menuDeleteError: "Error while deleting menu item.",
    menuCreateSuccessfully: "Menu item has been created successfully",
    menusCreateSuccessfully: "Menu items have been created successfully",
    menuCreateError: "Error while creating menu item.",
    menusCreateError: "Error while creating menu items.",
    menuUpdateSuccessfully: "Menu item has been updated successfully",
    menuUpdateError: "Error while updating menu item.",
    floorPlanSaveSuccessfully: "Floor plans have been saved successfully",
    floorPlanSaveError: "Error while saving floor plans.",
    sessionCreatedSuccessfully: "Session has been created successfully",
    sessionUpdatedSuccessfully: "Session has been updated successfully",
    sessionDeletedSuccessfully: "Session has been deleted successfully",
    sessionCreateError: "Error while saving session.",
    sessionDeleteError: "Error while deleting session.",
  },
  companyRegisterForm: {
    title: "Complete the form to create your account",
    skipForNow: "Skip for now",
    saveChangesAndCompleteLater: "Save and send later",
    saveChanges: "Save changes",
    modifyNow: "Make changes now",
    messageModalHasErrors:
      "Your info has been saved, but the form has not been submitted because some fields are incomplete or incorrect and require your attention.",
    titleModalHasErrors: "Form is incorrect or incomplete",
    messageModalHasNoErrors:
      "Hooray! The form has been submitted successfully. A member of our team will be in touch with you shortly.",
    titleModalHasNoErrors: "Form sent",
    fiscalInformation: "Fiscal Information",
    companyRegistrationNumber: "Company Registration Number",
    companyName: "Company Name",
    companyType: "Company Type",
    companyRegistrationCountry: "Company Registration Country",
    euVatNumber: "EU-VAT Number",
    tradeRegistryNumber: "Trade Registry Number",
    invoiceSeries: "Invoicing series",
    invoiceNumber: "Invoicing number",
    europeanUniqueIdentifier: "European Unique Identifier",
    vatObligations: "VAT Obligations",
    vatObligationsOpt1: "Yes",
    vatObligationsOpt2: "No",
    companyLegalAddress: "Company Legal Address",
    country: "Country / State",
    city: "City",
    county: "County",
    streetName: "Street Name",
    number: "Number",
    postalCode: "Postal Code",
    legalRepresentative: "Legal Representative",
    firstName: "First Name",
    lastName: "Last Name",
    telephone: "Telephone",
    emailAddress: "Email Address",
    bankDetails: "Bank Details",
    iban: "IBAN",
    bankName: "Bank Name",
    swift: "SWIFT",
    currency: "Currency",
    documents: "Documents",
    uploadTheFollowingRequiredDocuments:
      "Upload the following documents needed for the selling of the tickets",
    uploadTheFollowingOptionalDocuments:
      "Upload the following documents needed for the automatic report at DITL (optional)",
    optionalDocumentsDetails:
      "This service is intended for event organizers and is provided by Nightz, free of charge. " +
      "This service can be activated/deactivated from the event publishing form.",
    getTemplate: "Get Template",
    name: "Name",
    size: "Size",
    type: "Type",
    modified: "Modified",
    actions: "Actions",
    finalStep: "Final Step",
    deleteAll: "Delete All",
    uploadFiles: "Upload Files",
    uploadFile: "Upload",
    back: "Back",
    next: "Next",
    finalStep1: "Hooray!",
    finalStep2: "You completed the form!",
    finalStep3:
      "Take one more look to make sure all the information is correct.",
    finalStep4:
      "We will review your application shortly and notify you when your account will be activated and you will be able to publish events.",
    sendApplication: "Send Application",
    okButton: "Ok",
    contactDetails: "Contact Details",
    delete: "Delete",
    view: "View",
    saveDataAndSkipForNow: "The data has been saved.",
    uploadedDocuments: "Uploaded Documents",
    noDocumentsUploaded: "No documents uploaded",
    accordingToOriginalText:
      "All the copies must be signed and they also must contain the text: 'Conform cu originalul'. ",
  },
  eventTaxReports: {
    ticketRegistration: "Ticket Registration",
    neccesaryDocuments: "Necessary Documents",
    dowloadAll: "Download All",
    ditlRegistration: "DITL Registration",
    taxReporting: "Tax Reporting",
    attention: "Attention!",
    attentionDescription:
      "Companies wishing to have reporting done by Nightz should upload the following documents in the `My Business` section:",
    availableBelow: "available below",
    autogenerated: "autogenerated",
    goToMyBusiness: "Go to My Business",
    justNGO: "(Just NGO)",
    downloadTemplate: "Download a template document",
    viewDocument: "View the document",
  },

  eventStatistics: {
    dateSelectorLabelOpt1: "7 dayz",
    dateSelectorLabelOpt2: "14 days",
    dateSelectorLabelOpt3: "30 days",
    dateSelectorLabelOpt4: "Custom",
    salesOverview: "Sales Overview",
    revenueOverview: "Revenue Overview",
    totalRevenue: "Total Revenue",
    totalRevenueTickets: "Total Revenue Tickets",
    totalSoldTickets: "Total Sold Tickets",
    revenueByTicketType: "Revenue by Ticket Type",
    soldTicketsByTicketType: "No. of Sold Tickets by Ticket Type",
    totalActualSold: "Total",
  },
  userStatistics: {
    registersOverview: "Registers Overview",
  },
  eventAnalytics: {
    webOverview: "Web stats by source",
    platformOverview: "Stats by platform",
    tickets: "Tickets",
    ticketsBySource: "Tickets sold by source",
    reservationsBySource: "Reservations by source",
    ticketsByPlatform: "Tickets sold by platform",
    reservationsByPlatform: "Reservations by platform",
    marketingLink: "Marketing link",
    marketingDescription: "Create custom links to track where your clients are coming from. For example, you can set different links for your Instagram, Facebook, TikTok or Mail campaigns. ",
    eventLink: "Listing link",
    copyLink: "Copy link",
    clientsBook: "Guest book",
    importClients: "Import clients",
    importClientsHelp1: "1. Download the provided Excel template ",
    importClientsHelp2: "here.",
    importClientsHelp3: "2. Fill in the details of your clients in the correct columns.",
    importClientsHelp4: "3. Upload the document with the same format provided by us.",
    importClientsHelp5: "Note: Make sure the phone number field contains the country prefix (e.g. 40711223344 or +40711223344)",
    source: "Source name",
    linkCopied: "Link copied!",
    table: {
      source: "Source",
      sessions: "Sessions",
      addToCart: "Add to cart",
      reservations: "Reservations",
      purchases: "Purchases",
      revenue: "Revenue"
    }
  },

  invoicesTable: {
    create: "Create",
    tableTitle: "Invoices",
    invoiceTotal: "Total",
    invoicePaid: "Paid",
    invoiceDetails: "Invoice Details",
    invoiceUnpaid: "Unpaid",
    changeStatus: "Change Status",
    exportPdf: "Export pdf",
    exportXml: "Export xml",
    deleteInvoices: "Delete Invoices",
    documentType: "Document Type",
    company: "Company",
    documentNumberInputPlaceholder: "Search by Document Number",
    companyNameInputPlaceholder: "Search by Company Name",
    eventInputPlaceholder: "Search by Event",
    amount: "Amount",
    type: "Type",
    created: "Created",
    status: "Status",
    name: "Name",
    noInvoices: "No invoices yet, try other filters",
    changeStatusTo: "Change status to",
    statues: {
      invoiced: "INVOICED",
      paid: "PAID",
    },
    invoiced: "Invoiced",
    paid: "Paid",
    event: "Event",
    documentName: "Document name",
    startDate: "Start date",
    endDate: "End date",
    validFrom: "Valid from",
    validTo: "Valid to",
    invoice: "Invoice",
    autoInvoice: "Auto Invoice",
    compenAgreement: "Compensation agreement",

    INVOICE: "Invoice",
    AUTO_INVOICE: "Auto Invoice",
    COMPENSATION_AGREEMENT: "Compensation agreement",
  },

  seasonPassesTable: {
    seasonPass: "Season Pass",
    tableTitle: "Season Passes",
    seasonPasses: "Season passes",
    included: "Included in season pass",
    availablePasses: "Available passes"
  },
  transactionsTable: {
    tableTitle: "Transactions",
    eventTransactions: "Event Transactions",
    export: "Export",
    createInvoice: "Create Invoice",
    searchIdAndSeries: "Search by Order ID or Ticket Series",
    searchNameMailPhone: "Search by Buyer Name, Email or Phone",
    orderId: "Order ID",
    clientOrderStatus: "Client Order Status",
    purchaseDate: "Purchase Date",
    tickets: "Tickets",
    orderID: "Order ID",
    invoicingStatus: "Invoicing status ",
    name: "Name",
    phone: "Phone",
    email: "Email",
    total: "Total",
    event: "Event",
    company: "Company",
    companyInvoiceStatus: "Company Invoice Status",
    orderStatus: "Order Status",
    genericError: "A problem occurred! Please try again later.",
    documentType: "Document type",
    startDate: "Start date",
    endDate: "End date",
    status: "Status",
    statuses: {
      COMPLETED: "COMPLETED",
      FAILED: "FAILED",
      PENDING: "PENDING",
      REFUNDED: "REFUNDED",
    },
    invoice: "Invoice",
    message1: "No transactions.",
    message2: "Once a transaction is made, it will appear here",
    personalDetails: "Personal Details",
    businessDetails: "Business Details",
  },
  usersTable: {
    tableTitle: "Users",
    searchNameMailPhone: "Search by Buyer Name, Email or Phone",
    details: "Details",
    name: "Name",
    phone: "Phone",
    email: "Email",
    createdAt: "Created at",
    isDeleted: "Is deleted",
    totalActivities: "Activities",
    totalReservations: "Reservations",
    totalFriends: "Friends",
    totalCompletedOrders: "Completed orders",
    lastReservation: "Last reservation",
    lastOrder: "Last order",
    totalSpent: "Total spent",
    phoneCampaign: "Phone campaign",
    emailCampaign: "Email campaign",
    agreedToCampaign: "Agreed to be contacted",
    notificationCampaign: "Notification campaign",
    genericError: "A problem occurred! Please try again later.",
    startDate: "Start date",
    endDate: "End date",
    reservationStartDate: "Last reservation start date",
    reservationEndDate: "Last reservation end date",
    orderStartDate: "Last order start date",
    orderEndDate: "Last order end date",
    clearDates: "Clear filters",
    deletedStatus: "Status",
    statuses: {
      ALL: "ALL",
      EXISTING: "EXISTING",
      DELETED: "DELETED",
    },
    message1: "No users.",
    message2: "Once an account is created, it will appear here",
    true: "Yes",
    false: "No"
  },

  invoicesDetails: {
    titlePage: "Invoice Details",
    currentFilters: "Current Filters",
    eventId: "Event ID",
    createdFrom: "Created from",
    createdTo: "Created to",
    companyId: "Company ID",
    noDraftsData: "No draft data",
  },

  ticketTable: {
    name: "Name",
    serialNumber: "Serial Number",
    initialTickets: "Initial Tickets",
    initialVouchers: "Initial Vouchers",
    remainingTickets: "Remaining Tickets",
    remainingVouchers: "Remaining Vouchers",
    displayedPrice: "Displayed Price",
    visibility: "Visibility",
    genericError: "A problem occurred! Please try again later.",
    ticketTableNoDataTitle: "No tickets yet",
    ticketTableNoDataDescription:
      "Once a ticket is bought, it will appear here",
    excelOptions: {
      ticketsOnly: "All unfiltered Tickets",
      filteredTickets: "Filtered Tickets",
    },
  },
  documents: {
    registrationCertificatefromNationalTradeRegistry:
      "Unique Registration Certificate / Fiscal Registration Certificate",
    contractNightzB2B: "Contract Nightz B2B",
    termsAndConditionsForPartners: "Terms and Conditions for Partners",
    decontForm: "Decont Form",
    articleOfIncorporation: "Article Of Incorporation",
    ticketRegistrationForm: "Ticket Registration Form",
    mandateForNightz: "Mandate for Nightz",
    idCard: "ID Card",
    articleOfAssociation: "Article of Association",
    unsoldTicketsForm: "Unsold Tickets Form",
    wasGenerated: "Document {{documentName}} was generated",
    wasNotGenerated: "Could not generate the {{documentName}} document",
  },
  deletedMessages: {
    deletedName: "Deleted Name",
    deletedEmail: "Deleted Email",
    deletedPhone: "Deleted Phone",
    deletedCompany: "Deleted Company",
    deletedAccount: "Deleted Account",
    deletedCui: "Deleted Cui",
    deletedStatus: "Deleted Status",
  },
  apiErrorCodes: {
    NIGHTZ_ERROR_SEATSIO_BOOKING_FAILED:
      "The seats are no longer available. Please choose different seats! This happens if the holding time for the seats expired and someone else bought them. If the blocked seats have not been bought, they become free again in 15 min",
    NIGHTZ_ERROR_RESERVATION_FAILED:
      "Checkout fails because the configured reservation is not available anymore. Consider clearing you cart and try a new booking configuration",
  },
  resourceNotAvailable: {
    title: "Resource not available",
    description:
      "Sorry, we could not load the resource you’re looking for. Perhaps you are not not logged in with the correct user",
  },
};

export default en;
